import React from "react";

const MessageBlastContent = ({ data, view, messageContent }) => {
  const responsiveClass = {
    monitor: "w-[1024px]",
    tablet: "w-[768px]",
    mobile: "w-[425px]",
  };

  return (
    <div className="flex justify-center min-h-screen py-8">
      <div
        className={`rounded-lg p-8 ${responsiveClass[view] || "w-[1024px]"}`}
      >
        {/* Header Section */}
        <div className="flex justify-between items-center mb-6">
          {/* Sender Profile */}
          <div className="flex items-center gap-4">
            <img
              src={"https://placehold.co/50?text=Avatar"}
              alt="Avatar"
              className="w-12 h-12 rounded-full"
            />
            <div>
              <div className="font-medium text-lg">
                {data.from_name || "Sender Name"}
              </div>
              <div className="text-sm text-gray-500">
                {data.senderRole || "Sender Role"}
              </div>
            </div>
          </div>

          {/* Logo */}
          <img
            src="images/logo.svg"
            className="w-[118px] h-[32px]"
            alt="logo"
          />
        </div>

        {/* Content Box */}
        <div className="bg-white my-6 p-6 rounded-md shadow-md font-normal">
          <h1 className="text-xl font-bold mb-4">
            {data.subject || "Email Subject"}
          </h1>
          <hr className="border-gray-300 my-4" />
          <div
            className="mb-4"
            dangerouslySetInnerHTML={{
              __html: messageContent || "<p>Email body content goes here.</p>",
            }}
          />

          {/* QR Code or Additional Content */}
          <div className="border-t pt-4">
            <h2 className="text-lg font-bold mb-2">Check-in Information</h2>
            <div className="flex-col items-center gap-4">
              <img
                src={"https://placehold.co/180?text=QR+Code"}
                className="w-24 h-24"
                alt="QR Code"
              />
              <div>
                <p>Number of guests: {"N/A"}</p>
                <p>Table Number: {"N/A"}</p>
              </div>

              <div className="mt-4">
                <p>
                  {
                    "Show this QR Code to the operator for check in during the event day. Check the link above for the live newest update."
                  }
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="text-left text-sm text-gray-500 pt-4">
          {data.footer || (
            <>
              This email was sent from a no-reply address and cannot receive
              incoming emails. Please do not respond to this message.
              <br />
              <br />
              © 2024 Occurlab. All rights reserved.
              <br />
              <br />
              For more questions, please contact us at contact@example.com or
              call (123) 456-7890.
              <br />
              <br />
              This email was intended for guests who registered for our event.
              If you did not sign up, received this message by mistake, or
              believe there has been an error with the email address, please
              disregard this email or reach out to our customer service team at
              contact@example.com to correct the issue and prevent further
              communications.
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default MessageBlastContent;
